/* src/app/payroll/employee-payroll-item/employee-payroll-item-container/employee-payroll-item-container.component.scss */
.payroll-workspace-tabs {
  margin-top: 0.75rem;
}
.employee-payroll-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  align-items: start;
  margin-top: 1rem;
}
.employee-payroll-grid__left,
.employee-payroll-grid__right {
  min-width: 0;
}
:host ::ng-deep .employee-payroll-grid__left > .p-panel,
:host ::ng-deep .employee-payroll-grid__right > .p-panel {
  display: block;
  min-height: 35vh;
  max-height: 70vh;
}
:host ::ng-deep .employee-payroll-grid__left > .p-panel .p-panel-content,
:host ::ng-deep .employee-payroll-grid__right > .p-panel .p-panel-content {
  min-height: 35vh;
  max-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep ef-employee-base-rate-presenter,
:host ::ng-deep ef-employee-payroll-item-presenter {
  display: block;
  height: 100%;
}
@media (max-width: 1100px) {
  .employee-payroll-grid {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=employee-payroll-item-container.component.css.map */
